export const isCardPage = (user) => {
  if (['mega-dev@profound.com', 'jake@profoundpros.com'].includes(user.email)) {
    return true;
  }
  return false;
};
